import React from "react";
import { ShieldCheck } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Reveal } from "@/components/Reveal";

const CERTS = [
  { n: "NMEA 2000",       tag: { en: "Certified installer", es: "Instalador certificado" } },
  { n: "Furuno",          tag: { en: "Authorized service",  es: "Servicio autorizado" } },
  { n: "Raymarine",       tag: { en: "Authorized service",  es: "Servicio autorizado" } },
  { n: "Garmin",          tag: { en: "Authorized service",  es: "Servicio autorizado" } },
  { n: "Airmar Systems",  tag: { en: "Authorized service",  es: "Servicio autorizado" } },
];

const COPY = {
  en: {
    kicker: "Certifications",
    title: "Trained. Audited. Trusted.",
    sub: "We install to spec because we've been factory-trained and certified by the brands captains rely on — from the NMEA 2000 backbone to the last sensor at the mast.",
  },
  es: {
    kicker: "Certificaciones",
    title: "Formados. Auditados. Confiables.",
    sub: "Instalamos según especificación porque estamos entrenados y certificados de fábrica por las marcas en las que confían los capitanes — desde el backbone NMEA 2000 hasta el último sensor en el mástil.",
  },
};

export default function Certifications() {
  const { lang } = useApp();
  const c = COPY[lang] || COPY.en;

  return (
    <section id="certs" className="relative py-24 lg:py-32 bg-navy text-white overflow-hidden" data-testid="certs-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-[420px_1fr] gap-14 items-start">
        <Reveal>
          <div className="flex items-center gap-2 text-brass mb-4">
            <ShieldCheck className="w-4 h-4" />
            <span className="font-mono text-[11px] tracking-[0.28em] uppercase">{c.kicker}</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-[1.05]">{c.title}</h2>
          <p className="mt-6 max-w-md text-slate leading-relaxed">{c.sub}</p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {CERTS.map((cert, i) => (
            <Reveal key={cert.n} delay={i * 0.06}>
              <div
                className="group relative rounded-2xl border border-cyan/25 bg-ink/40 backdrop-blur-sm p-6 h-full flex flex-col justify-between overflow-hidden hover:border-brass/60 hover:-translate-y-0.5 transition-all duration-300"
                data-testid={`cert-card-${i}`}
              >
                <div className="absolute -top-14 -right-14 w-32 h-32 rounded-full bg-cyan/10 blur-2xl group-hover:bg-brass/15 transition-colors" />
                <div className="flex items-center justify-between mb-8">
                  <span className="font-mono text-[10px] tracking-[0.28em] uppercase text-cyan/80">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <ShieldCheck className="w-4 h-4 text-brass/70 group-hover:text-brass transition-colors" />
                </div>
                <div>
                  <p className="font-display text-2xl md:text-3xl tracking-tight leading-none">{cert.n}</p>
                  <p className="mt-3 font-mono text-[11px] tracking-[0.15em] uppercase text-slate">
                    {cert.tag[lang] || cert.tag.en}
                  </p>
                </div>
                <div className="mt-6 h-px w-0 bg-brass group-hover:w-full transition-all duration-500" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
